var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRightWhite = function SvgChevronRightWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.467 5 7 7-7 7L8 17.533 13.533 12 8 6.467 9.467 5Z",
    fill: "#fff"
  })));
};
export { SvgChevronRightWhite as ReactComponent };
export default __webpack_public_path__ + "1dc923ad710bd711745731019f14ed2a.svg";